import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import * as AHooks from 'ahooks';
import { FI18n, FUtil } from '@freelog/tools-lib';
import FIcons from '@/components/FIcons';

interface FExpandableProps {
  children: React.ReactNode;
  dep?: string;
  /** 展开/收起按钮对齐，默认居中 */
  footerAlign?: 'center' | 'end';
  /** 按钮放在内容区外（简介灰底区域下方） */
  footerOutside?: boolean;
  /** 收起时底部渐变遮罩底色 */
  maskTone?: 'white' | 'gray';
}

function FExpandable({
  children,
  dep,
  footerAlign = 'center',
  footerOutside = false,
  maskTone = 'white',
}: FExpandableProps) {
  const refContent = React.useRef<any>();
  const [$height, set$height, get$height] = FUtil.Hook.useGetState<number>(0);
  const [expandable, setExpandable] = FUtil.Hook.useGetState<boolean | null>(false);

  AHooks.useDebounceEffect(() => {

    const currentHeight: number = refContent.current.clientHeight;
    if (get$height() === currentHeight) {
      return;
    }
    set$height(currentHeight);
    if (currentHeight > 300) {
      setExpandable(false);
    } else {
      setExpandable(null);
    }
  }, [children], {
    wait: 30,
  });

  const footerClassName = [
    styles.footer,
    footerAlign === 'end' ? styles.footerEnd : '',
    footerOutside ? styles.footerOutside : '',
  ]
    .filter(Boolean)
    .join(' ');

  const collapseBtn = (
    <FComponentsLib.FTextBtn
      type='primary'
      onClick={() => {
        setExpandable(false);
      }}
    >
      <span>
        {
          // 收起
          FI18n.i18nNext.tAuto('btn_show_less')
        }{' '}
        <FIcons.FUp style={{ fontSize: 12 }} />
      </span>
    </FComponentsLib.FTextBtn>
  );

  const expandBtn = (
    <FComponentsLib.FTextBtn
      type='primary'
      onClick={() => {
        setExpandable(true);
      }}
    >
      <span>
        {
          // 展开
          FI18n.i18nNext.tAuto('btn_show_more')
        }{' '}
        <FIcons.FDown style={{ fontSize: 12 }} />
      </span>
    </FComponentsLib.FTextBtn>
  );

  if (footerOutside) {
    return (
      <div className={styles.root}>
        <div className={[styles.body, styles.bodyOutside].join(' ')}>
          <div className={styles.content} style={expandable == false ? { height: 300 } : {}}>
            <div ref={refContent}>{children}</div>
          </div>
          {expandable === false && (
            <div className={[styles.mask, maskTone === 'gray' ? styles.maskGray : ''].filter(Boolean).join(' ')} />
          )}
        </div>
        {expandable !== null && (
          <div className={footerClassName}>
            {expandable ? collapseBtn : expandBtn}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={styles.styles}>
      {expandable !== null && !footerOutside && (
        <div className={styles.button}>
          {expandable && collapseBtn}
        </div>
      )}

      <div className={styles.content} style={expandable == false ? { height: 300 } : {}}>
        <div ref={refContent}>{children}</div>
      </div>

      {expandable === false && (
        <div className={[styles.mask, maskTone === 'gray' ? styles.maskGray : ''].filter(Boolean).join(' ')} />
      )}

      {expandable !== null && (
        <div className={[styles.closeButton, footerAlign === 'end' ? styles.closeButtonEnd : ''].filter(Boolean).join(' ')}>
          {expandable === false && expandBtn}
        </div>
      )}
    </div>
  );
}

export default FExpandable;
